





































import { Prop, Component, Vue } from "vue-property-decorator";

import SpecialPageCarousel from "@/general/components/cms/view_type/SpecialPageCarousel.vue";
import SpecialPageColumn from "@/general/components/cms/view_type/SpecialPageColumn.vue"
import SpecialPageDetail from "@/general/components/cms/view_type/SpecialPageDetail.vue";

import TopPageApi from "@/general/api/topPageApi";

@Component({
  components: {
    SpecialPageColumn,
    SpecialPageDetail,
    SpecialPageCarousel
  }
})
export default class SpecialPage extends Vue {
  @Prop({ type: String, default: "" }) view_type!: string;
  @Prop({ type: String, default: "" }) page_limit!: string;
  @Prop({ type: String, default: "" }) view_area!: string;
  @Prop({ type: String, default: null }) special_category!: string;
  @Prop({ type: Boolean, default: true }) show_more!: boolean;

  error: any = null;
  CMS_response = null;
  ApiResponse = {
    data: {},
    isError: false
  };
  isLoading = true;

  async created() {
    if(this.view_type === 'detail') {
      this.isLoading = false;
      return;
    } else {
      await this.readcms();
    }
    this.isLoading = false;
  }

  async readcms() {
    const APIres = await TopPageApi.getSpecialPage({
      page_limit: this.page_limit,
      view_area: this.view_area,
      contract_id: null,
      course_id: null
    });
    this.ApiResponse.data = APIres;
    this.ApiResponse.isError = APIres?.isError;

    if (this.ApiResponse.isError) {
      this.error = "コンテンツの読み込みに失敗しました";
    } else {
      return this.setResponse(this.ApiResponse);
    }
  }

  setResponse(obj: any) {
    if (
      !obj ||
      !obj.data ||
      !obj.data.data ||
      !obj.data.included ||
      !obj.data.included[0]
    ) {
      return;
    }
    this.CMS_response = obj.data;
  }

  setTitle(title: string) {
    this.$emit("catchTitle", title);
  }
}
